export type ApiConfig = {
  apiUrl: string;
  AVMLink: string;
  scenarioExample: string;
  scenarioDemo: string;
};

const API_URLS = {
  production: import.meta.env['VITE_FIGMA_PLUGIN_API_URL_PROD'],
  staging: import.meta.env['VITE_FIGMA_PLUGIN_API_URL_STAGING'],
  develop: import.meta.env['VITE_FIGMA_PLUGIN_API_URL_DEV'],
};

const MAIN_APP_LINKS = {
  production: import.meta.env['VITE_FIGMA_PLUGIN_MAIN_APP_LINK_PROD'],
  staging: import.meta.env['VITE_FIGMA_PLUGIN_MAIN_APP_LINK_STAGING'],
  develop: import.meta.env['VITE_FIGMA_PLUGIN_MAIN_APP_LINK_DEV'],
};

// Currently Figma doesn't support any custom options in manifest.json nor including custom config files
// so we have to use pluginId to determine which API url to use.
// API url's are defined in environment variables and injected once during build time.
// Manifest file is generated before deployment so we don't have to rebuild plugin between target environments.
export const getApiBasedConfig = (): ApiConfig => {
  const mode = figma.pluginId?.split('-').pop() as
    | keyof typeof API_URLS
    | undefined;

  if (!mode || !API_URLS[mode]) {
    return {
      apiUrl: API_URLS.production,
      AVMLink: MAIN_APP_LINKS.production,
      scenarioExample: import.meta.env.VITE_FIGMA_PLUGIN_EXAMPLE_PLAYGROUND,
      scenarioDemo: import.meta.env.VITE_FIGMA_PLUGIN_DEMO,
    };
  }

  return {
    apiUrl: API_URLS[mode],
    AVMLink: MAIN_APP_LINKS[mode],
    scenarioExample: import.meta.env.VITE_FIGMA_PLUGIN_EXAMPLE_PLAYGROUND,
    scenarioDemo: import.meta.env.VITE_FIGMA_PLUGIN_DEMO,
  };
};
